import { mapState } from 'vuex';
export default {
	computed: {
		...mapState('newsModule', ['currentPage'])
	},
	mounted() {
		this.$scrollTo(this.$refs['highlighted-news-top']);
	}
};
